//This grid footer component has a button to export the grid data and a select dropdown to change the number of rows in a page.
//If you use the component, you must call initialize() after the page is loaded.
//When the user changes the page size, it's saved in sessionStorage so that if you come back to the page later, it will remember.
import { Component, OnInit, ViewEncapsulation, ViewChild } from '@angular/core';

@Component({
  selector: 'grid-footer',
  templateUrl: './grid-footer.component.html',
  styleUrls: ['./grid-footer.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class GridFooterComponent implements OnInit {
  sessionStorageKey: string;
  uniqueName: string;
  gridApi;
  columnsToExport;
  @ViewChild('pageSizeSelect') pageSizeSelect;
 
  constructor() {}

  ngOnInit() {
  }

  //uniqueName is used in the file name of the exported file and to save the page size in sessionStorage (which is why it must be unique, so each grid in the system has a different value).
  //If you don't pass in columnsToExport, the default is to export them all.
  initialize(uniqueName: string, gridApi, defaultPageSize: number = 500, columnsToExport) {
    this.gridApi = gridApi;
    this.uniqueName = uniqueName;
    this.sessionStorageKey = "gridPageSize" + uniqueName;
    this.columnsToExport = columnsToExport;
    let numRecords: string = sessionStorage[this.sessionStorageKey];
    if (!numRecords) {
      numRecords = defaultPageSize.toString();
    }
    this.pageSizeSelect.nativeElement.value = numRecords;
    this.onGridPageSizeChanged();
  }

  //event for if the user clicks the button to export.
  public onExportGrid() {
    let params = {
      fileName: this.uniqueName + "_Grid_Data.csv",
      columnKeys: this.columnsToExport
    };
    this.gridApi.exportDataAsCsv(params);
  }

  //event for if the user changes the page size.
  public onGridPageSizeChanged() {
    let pageSize: string = this.pageSizeSelect.nativeElement.value;
    this.gridApi.paginationSetPageSize(Number(pageSize));
    sessionStorage[this.sessionStorageKey] = pageSize;
  }
}
